import { useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { QualifyDrawerForm } from "@/components/ExpertMode/QualifyDrawerForm";
import { OrderStatusEnum } from "@/config/apiClient.types";
import { useOrderItems, useOrders, usePageTemplate } from "@/hooks";
import { ModalCancelProductSelection } from "@/modals/expertMode";
import { NewRequestPageContent } from "./NewRequestPageContent";
import { NewRequestPageHeader } from "./NewRequestPageHeader";

export const NewRequestPage = () => {
  const { PageTemplateV2, isScrolled } = usePageTemplate();
  const {
    id: clientOrderItemId = "",
    orderItemId: brokerOrderItemId = "",
    orderId = "",
  } = useParams();

  const [isQualifyDrawerOpen, setIsQualifyDrawerOpen] = useState(false);
  const [
    isModalCancelProductSelectionOpen,
    setIsModalCancelProductSelectionOpen,
  ] = useState(false);

  const orderItemId = brokerOrderItemId || clientOrderItemId;

  const { useGetOrderItem } = useOrderItems();
  const { useGetOrder } = useOrders();
  const getOrderItemDetailsQueryResult = useGetOrderItem({
    orderId,
    orderItemId,
  });
  const getOrderQueryResult = useGetOrder({ orderId });

  const orderItem = getOrderItemDetailsQueryResult.data?.data?.orderItem;
  const order = getOrderQueryResult.data?.data;

  if (
    getOrderItemDetailsQueryResult?.isError ||
    !orderItem ||
    !orderItem?.order ||
    !order
  ) {
    return null;
  }

  if (orderItem?.status !== OrderStatusEnum.TO_STUDY) {
    return <Navigate to={`/orders/${orderId}/order-items/${orderItemId}`} />;
  }

  return (
    <PageTemplateV2>
      <PageTemplateV2.Header>
        <NewRequestPageHeader
          order={order}
          orderItem={orderItem}
          isScrolled={isScrolled}
          handleDeleteRequest={() => setIsModalCancelProductSelectionOpen(true)}
          handleQualifyDrawerOpen={() => setIsQualifyDrawerOpen(true)}
        />
      </PageTemplateV2.Header>

      <PageTemplateV2.Content px="sp-xl3" py="sp-xl" mb="sp-xl3">
        <NewRequestPageContent
          orderItem={orderItem}
          order={order}
          handleQualifyDrawerOpen={() => setIsQualifyDrawerOpen(true)}
        />
      </PageTemplateV2.Content>

      <QualifyDrawerForm
        isOpen={isQualifyDrawerOpen}
        handleOpenChange={() => setIsQualifyDrawerOpen(false)}
        onSave={() => {}}
      />

      <ModalCancelProductSelection
        isOpen={isModalCancelProductSelectionOpen}
        selectedOrderItems={[
          {
            name: orderItem.sandboxItem?.name || "",
            orderItemId: orderItem?.id || "",
            orderId,
          },
        ]}
        onOpenChange={() => setIsModalCancelProductSelectionOpen(false)}
      />
    </PageTemplateV2>
  );
};
